import React from "react";
import { Redirect } from "react-router-dom";
import { Mutation } from "react-apollo";
import { DELETE_REGION } from "../../../graphql";
import Button from "../../UI/Button";
import RegionSelect from "../../Region/Select/Container"

import {
  Spacer,
  Tgrid,
  tbGrids
} from "../../../components/Layout/Layout";

class RegionDeleteForm extends React.Component {
  state = {
    regionID: ""
  };

  handleInputChange = (name, value) => {
    this.setState({
      [name]: value
    });
  };

  
  render() {
    return (
      <Mutation mutation={DELETE_REGION}>
        {(deleteRegion, { data, loading, called, error }) => {
          if (called && !error && !loading) {
            if (data.deleteRegion) {
              return (
                <Redirect
                  to={{
                    pathname: "/",
                    state: {
                      message: `Region ${
                        data.deleteRegion.name
                      } successfully deleted`
                    }
                  }}
                />
              );
            }
          }

          return (
            <React.Fragment>
                <form
                onSubmit={e => {
                  e.preventDefault();
                  deleteRegion({ variables: { id: this.state.regionID } });
                }}
              >
                <Spacer>
                  
                  <Tgrid gr={tbGrids.grid70}>
                  <Spacer>
                      <RegionSelect required onChange={value=>this.handleInputChange("regionID",value)}/>
                    </Spacer>
                  </Tgrid>
                  <Tgrid gr={tbGrids.grid30}>
                  <Spacer><Button type="submit" disabled={loading}>
                      Delete
                    </Button></Spacer>

                  
                  </Tgrid>
                  
                </Spacer>
              </form>
              
            </React.Fragment>
          );
        }}
      </Mutation>
    );
  }
}

export default RegionDeleteForm;